/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ResourcesRouteImport } from './routes/resources'
import { Route as LangRouteImport } from './routes/$lang'
import { Route as IndexRouteImport } from './routes/index'
import { Route as VerifyEmailIndexRouteImport } from './routes/verify-email/index'
import { Route as ResourcesIndexRouteImport } from './routes/resources/index'
import { Route as ConfirmEmailChangeIndexRouteImport } from './routes/confirm-email-change/index'
import { Route as LangIndexRouteImport } from './routes/$lang/index'
import { Route as LangTrustRouteImport } from './routes/$lang/trust'
import { Route as LangTermsRouteImport } from './routes/$lang/terms'
import { Route as LangSolutionsRouteImport } from './routes/$lang/solutions'
import { Route as LangSecurityRouteImport } from './routes/$lang/security'
import { Route as LangResourcesRouteImport } from './routes/$lang/resources'
import { Route as LangRefundPolicyRouteImport } from './routes/$lang/refund-policy'
import { Route as LangPrivacyRouteImport } from './routes/$lang/privacy'
import { Route as LangPricingRouteImport } from './routes/$lang/pricing'
import { Route as LangPendingApprovalRouteImport } from './routes/$lang/pending-approval'
import { Route as LangIntegrationsRouteImport } from './routes/$lang/integrations'
import { Route as LangDemoRouteImport } from './routes/$lang/demo'
import { Route as LangCheckEmailRouteImport } from './routes/$lang/check-email'
import { Route as LangAppRouteImport } from './routes/$lang/app'
import { Route as LangWorkspaceIndexRouteImport } from './routes/$lang/workspace/index'
import { Route as LangVerifyEmailIndexRouteImport } from './routes/$lang/verify-email/index'
import { Route as LangSubscriptionIndexRouteImport } from './routes/$lang/subscription/index'
import { Route as LangSignupIndexRouteImport } from './routes/$lang/signup/index'
import { Route as LangSettingsIndexRouteImport } from './routes/$lang/settings/index'
import { Route as LangResourcesIndexRouteImport } from './routes/$lang/resources/index'
import { Route as LangOrganizationIndexRouteImport } from './routes/$lang/organization/index'
import { Route as LangLoginIndexRouteImport } from './routes/$lang/login/index'
import { Route as LangHomeIndexRouteImport } from './routes/$lang/home/index'
import { Route as LangDashboardIndexRouteImport } from './routes/$lang/dashboard/index'
import { Route as LangConfirmEmailChangeIndexRouteImport } from './routes/$lang/confirm-email-change/index'
import { Route as LangBillingIndexRouteImport } from './routes/$lang/billing/index'
import { Route as LangAuthIndexRouteImport } from './routes/$lang/auth/index'
import { Route as ResourcesCategorySlugRouteImport } from './routes/resources/$category/$slug'
import { Route as OauthGithubCompleteRouteImport } from './routes/oauth/github/complete'
import { Route as LangWorkspaceCreateRouteImport } from './routes/$lang/workspace/create'
import { Route as LangSubscriptionPilotRouteImport } from './routes/$lang/subscription/pilot'
import { Route as LangSubscriptionOrganizationRouteImport } from './routes/$lang/subscription/organization'
import { Route as LangSettingsOrganizationRouteImport } from './routes/$lang/settings/organization'
import { Route as LangSettingsGeneralRouteImport } from './routes/$lang/settings/general'
import { Route as LangSettingsBillingRouteImport } from './routes/$lang/settings/billing'
import { Route as LangSettingsAiIntegrationsRouteImport } from './routes/$lang/settings/ai-integrations'
import { Route as LangOrgInvitesTokenRouteImport } from './routes/$lang/org-invites/$token'
import { Route as LangOnboardingFreeRouteImport } from './routes/$lang/onboarding/free'
import { Route as LangMcpAuthorizeRouteImport } from './routes/$lang/mcp/authorize'
import { Route as LangInvitesInviteIdRouteImport } from './routes/$lang/invites/$inviteId'
import { Route as LangGtmRunIdRouteImport } from './routes/$lang/gtm/$runId'
import { Route as LangWorkspaceWorkspaceIdIndexRouteImport } from './routes/$lang/workspace/$workspaceId/index'
import { Route as LangOrganizationAutomationsIndexRouteImport } from './routes/$lang/organization/automations/index'
import { Route as LangOrganizationAgentsIndexRouteImport } from './routes/$lang/organization/agents/index'
import { Route as LangWorkspaceWorkspaceIdSettingsRouteImport } from './routes/$lang/workspace/$workspaceId/settings'
import { Route as LangResourcesCategorySlugRouteImport } from './routes/$lang/resources/$category/$slug'
import { Route as LangOrganizationAgentsNewRouteImport } from './routes/$lang/organization/agents/new'
import { Route as LangGtmStartCheckoutIdRouteImport } from './routes/$lang/gtm/start/$checkoutId'
import { Route as LangGtmPurchaseCheckoutIdRouteImport } from './routes/$lang/gtm/purchase/$checkoutId'
import { Route as LangWorkspaceWorkspaceIdGtmIndexRouteImport } from './routes/$lang/workspace/$workspaceId/gtm/index'
import { Route as LangWorkspaceWorkspaceIdAgentsIndexRouteImport } from './routes/$lang/workspace/$workspaceId/agents/index'
import { Route as LangWorkspaceWorkspaceIdGtmSettingsRouteImport } from './routes/$lang/workspace/$workspaceId/gtm/settings'
import { Route as LangWorkspaceWorkspaceIdGtmLeadsRouteImport } from './routes/$lang/workspace/$workspaceId/gtm/leads'
import { Route as LangWorkspaceWorkspaceIdGtmInboxRouteImport } from './routes/$lang/workspace/$workspaceId/gtm/inbox'
import { Route as LangWorkspaceWorkspaceIdGtmCampaignsRouteImport } from './routes/$lang/workspace/$workspaceId/gtm/campaigns'
import { Route as LangWorkspaceWorkspaceIdChatsChatIdRouteImport } from './routes/$lang/workspace/$workspaceId/chats/$chatId'
import { Route as LangWorkspaceWorkspaceIdAgentsNewRouteImport } from './routes/$lang/workspace/$workspaceId/agents/new'
import { Route as LangOrganizationAgentsAgentIdEditRouteImport } from './routes/$lang/organization/agents/$agentId/edit'
import { Route as LangWorkspaceWorkspaceIdAgentsAgentIdEditRouteImport } from './routes/$lang/workspace/$workspaceId/agents/$agentId/edit'

const ResourcesRoute = ResourcesRouteImport.update({
  id: '/resources',
  path: '/resources',
  getParentRoute: () => rootRouteImport,
} as any)
const LangRoute = LangRouteImport.update({
  id: '/$lang',
  path: '/$lang',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyEmailIndexRoute = VerifyEmailIndexRouteImport.update({
  id: '/verify-email/',
  path: '/verify-email/',
  getParentRoute: () => rootRouteImport,
} as any)
const ResourcesIndexRoute = ResourcesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ResourcesRoute,
} as any)
const ConfirmEmailChangeIndexRoute = ConfirmEmailChangeIndexRouteImport.update({
  id: '/confirm-email-change/',
  path: '/confirm-email-change/',
  getParentRoute: () => rootRouteImport,
} as any)
const LangIndexRoute = LangIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LangRoute,
} as any)
const LangTrustRoute = LangTrustRouteImport.update({
  id: '/trust',
  path: '/trust',
  getParentRoute: () => LangRoute,
} as any)
const LangTermsRoute = LangTermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => LangRoute,
} as any)
const LangSolutionsRoute = LangSolutionsRouteImport.update({
  id: '/solutions',
  path: '/solutions',
  getParentRoute: () => LangRoute,
} as any)
const LangSecurityRoute = LangSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => LangRoute,
} as any)
const LangResourcesRoute = LangResourcesRouteImport.update({
  id: '/resources',
  path: '/resources',
  getParentRoute: () => LangRoute,
} as any)
const LangRefundPolicyRoute = LangRefundPolicyRouteImport.update({
  id: '/refund-policy',
  path: '/refund-policy',
  getParentRoute: () => LangRoute,
} as any)
const LangPrivacyRoute = LangPrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => LangRoute,
} as any)
const LangPricingRoute = LangPricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => LangRoute,
} as any)
const LangPendingApprovalRoute = LangPendingApprovalRouteImport.update({
  id: '/pending-approval',
  path: '/pending-approval',
  getParentRoute: () => LangRoute,
} as any)
const LangIntegrationsRoute = LangIntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => LangRoute,
} as any)
const LangDemoRoute = LangDemoRouteImport.update({
  id: '/demo',
  path: '/demo',
  getParentRoute: () => LangRoute,
} as any)
const LangCheckEmailRoute = LangCheckEmailRouteImport.update({
  id: '/check-email',
  path: '/check-email',
  getParentRoute: () => LangRoute,
} as any)
const LangAppRoute = LangAppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => LangRoute,
} as any)
const LangWorkspaceIndexRoute = LangWorkspaceIndexRouteImport.update({
  id: '/workspace/',
  path: '/workspace/',
  getParentRoute: () => LangRoute,
} as any)
const LangVerifyEmailIndexRoute = LangVerifyEmailIndexRouteImport.update({
  id: '/verify-email/',
  path: '/verify-email/',
  getParentRoute: () => LangRoute,
} as any)
const LangSubscriptionIndexRoute = LangSubscriptionIndexRouteImport.update({
  id: '/subscription/',
  path: '/subscription/',
  getParentRoute: () => LangRoute,
} as any)
const LangSignupIndexRoute = LangSignupIndexRouteImport.update({
  id: '/signup/',
  path: '/signup/',
  getParentRoute: () => LangRoute,
} as any)
const LangSettingsIndexRoute = LangSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => LangRoute,
} as any)
const LangResourcesIndexRoute = LangResourcesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LangResourcesRoute,
} as any)
const LangOrganizationIndexRoute = LangOrganizationIndexRouteImport.update({
  id: '/organization/',
  path: '/organization/',
  getParentRoute: () => LangRoute,
} as any)
const LangLoginIndexRoute = LangLoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => LangRoute,
} as any)
const LangHomeIndexRoute = LangHomeIndexRouteImport.update({
  id: '/home/',
  path: '/home/',
  getParentRoute: () => LangRoute,
} as any)
const LangDashboardIndexRoute = LangDashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => LangRoute,
} as any)
const LangConfirmEmailChangeIndexRoute =
  LangConfirmEmailChangeIndexRouteImport.update({
    id: '/confirm-email-change/',
    path: '/confirm-email-change/',
    getParentRoute: () => LangRoute,
  } as any)
const LangBillingIndexRoute = LangBillingIndexRouteImport.update({
  id: '/billing/',
  path: '/billing/',
  getParentRoute: () => LangRoute,
} as any)
const LangAuthIndexRoute = LangAuthIndexRouteImport.update({
  id: '/auth/',
  path: '/auth/',
  getParentRoute: () => LangRoute,
} as any)
const ResourcesCategorySlugRoute = ResourcesCategorySlugRouteImport.update({
  id: '/$category/$slug',
  path: '/$category/$slug',
  getParentRoute: () => ResourcesRoute,
} as any)
const OauthGithubCompleteRoute = OauthGithubCompleteRouteImport.update({
  id: '/oauth/github/complete',
  path: '/oauth/github/complete',
  getParentRoute: () => rootRouteImport,
} as any)
const LangWorkspaceCreateRoute = LangWorkspaceCreateRouteImport.update({
  id: '/workspace/create',
  path: '/workspace/create',
  getParentRoute: () => LangRoute,
} as any)
const LangSubscriptionPilotRoute = LangSubscriptionPilotRouteImport.update({
  id: '/subscription/pilot',
  path: '/subscription/pilot',
  getParentRoute: () => LangRoute,
} as any)
const LangSubscriptionOrganizationRoute =
  LangSubscriptionOrganizationRouteImport.update({
    id: '/subscription/organization',
    path: '/subscription/organization',
    getParentRoute: () => LangRoute,
  } as any)
const LangSettingsOrganizationRoute =
  LangSettingsOrganizationRouteImport.update({
    id: '/settings/organization',
    path: '/settings/organization',
    getParentRoute: () => LangRoute,
  } as any)
const LangSettingsGeneralRoute = LangSettingsGeneralRouteImport.update({
  id: '/settings/general',
  path: '/settings/general',
  getParentRoute: () => LangRoute,
} as any)
const LangSettingsBillingRoute = LangSettingsBillingRouteImport.update({
  id: '/settings/billing',
  path: '/settings/billing',
  getParentRoute: () => LangRoute,
} as any)
const LangSettingsAiIntegrationsRoute =
  LangSettingsAiIntegrationsRouteImport.update({
    id: '/settings/ai-integrations',
    path: '/settings/ai-integrations',
    getParentRoute: () => LangRoute,
  } as any)
const LangOrgInvitesTokenRoute = LangOrgInvitesTokenRouteImport.update({
  id: '/org-invites/$token',
  path: '/org-invites/$token',
  getParentRoute: () => LangRoute,
} as any)
const LangOnboardingFreeRoute = LangOnboardingFreeRouteImport.update({
  id: '/onboarding/free',
  path: '/onboarding/free',
  getParentRoute: () => LangRoute,
} as any)
const LangMcpAuthorizeRoute = LangMcpAuthorizeRouteImport.update({
  id: '/mcp/authorize',
  path: '/mcp/authorize',
  getParentRoute: () => LangRoute,
} as any)
const LangInvitesInviteIdRoute = LangInvitesInviteIdRouteImport.update({
  id: '/invites/$inviteId',
  path: '/invites/$inviteId',
  getParentRoute: () => LangRoute,
} as any)
const LangGtmRunIdRoute = LangGtmRunIdRouteImport.update({
  id: '/gtm/$runId',
  path: '/gtm/$runId',
  getParentRoute: () => LangRoute,
} as any)
const LangWorkspaceWorkspaceIdIndexRoute =
  LangWorkspaceWorkspaceIdIndexRouteImport.update({
    id: '/workspace/$workspaceId/',
    path: '/workspace/$workspaceId/',
    getParentRoute: () => LangRoute,
  } as any)
const LangOrganizationAutomationsIndexRoute =
  LangOrganizationAutomationsIndexRouteImport.update({
    id: '/organization/automations/',
    path: '/organization/automations/',
    getParentRoute: () => LangRoute,
  } as any)
const LangOrganizationAgentsIndexRoute =
  LangOrganizationAgentsIndexRouteImport.update({
    id: '/organization/agents/',
    path: '/organization/agents/',
    getParentRoute: () => LangRoute,
  } as any)
const LangWorkspaceWorkspaceIdSettingsRoute =
  LangWorkspaceWorkspaceIdSettingsRouteImport.update({
    id: '/workspace/$workspaceId/settings',
    path: '/workspace/$workspaceId/settings',
    getParentRoute: () => LangRoute,
  } as any)
const LangResourcesCategorySlugRoute =
  LangResourcesCategorySlugRouteImport.update({
    id: '/$category/$slug',
    path: '/$category/$slug',
    getParentRoute: () => LangResourcesRoute,
  } as any)
const LangOrganizationAgentsNewRoute =
  LangOrganizationAgentsNewRouteImport.update({
    id: '/organization/agents/new',
    path: '/organization/agents/new',
    getParentRoute: () => LangRoute,
  } as any)
const LangGtmStartCheckoutIdRoute = LangGtmStartCheckoutIdRouteImport.update({
  id: '/gtm/start/$checkoutId',
  path: '/gtm/start/$checkoutId',
  getParentRoute: () => LangRoute,
} as any)
const LangGtmPurchaseCheckoutIdRoute =
  LangGtmPurchaseCheckoutIdRouteImport.update({
    id: '/gtm/purchase/$checkoutId',
    path: '/gtm/purchase/$checkoutId',
    getParentRoute: () => LangRoute,
  } as any)
const LangWorkspaceWorkspaceIdGtmIndexRoute =
  LangWorkspaceWorkspaceIdGtmIndexRouteImport.update({
    id: '/workspace/$workspaceId/gtm/',
    path: '/workspace/$workspaceId/gtm/',
    getParentRoute: () => LangRoute,
  } as any)
const LangWorkspaceWorkspaceIdAgentsIndexRoute =
  LangWorkspaceWorkspaceIdAgentsIndexRouteImport.update({
    id: '/workspace/$workspaceId/agents/',
    path: '/workspace/$workspaceId/agents/',
    getParentRoute: () => LangRoute,
  } as any)
const LangWorkspaceWorkspaceIdGtmSettingsRoute =
  LangWorkspaceWorkspaceIdGtmSettingsRouteImport.update({
    id: '/workspace/$workspaceId/gtm/settings',
    path: '/workspace/$workspaceId/gtm/settings',
    getParentRoute: () => LangRoute,
  } as any)
const LangWorkspaceWorkspaceIdGtmLeadsRoute =
  LangWorkspaceWorkspaceIdGtmLeadsRouteImport.update({
    id: '/workspace/$workspaceId/gtm/leads',
    path: '/workspace/$workspaceId/gtm/leads',
    getParentRoute: () => LangRoute,
  } as any)
const LangWorkspaceWorkspaceIdGtmInboxRoute =
  LangWorkspaceWorkspaceIdGtmInboxRouteImport.update({
    id: '/workspace/$workspaceId/gtm/inbox',
    path: '/workspace/$workspaceId/gtm/inbox',
    getParentRoute: () => LangRoute,
  } as any)
const LangWorkspaceWorkspaceIdGtmCampaignsRoute =
  LangWorkspaceWorkspaceIdGtmCampaignsRouteImport.update({
    id: '/workspace/$workspaceId/gtm/campaigns',
    path: '/workspace/$workspaceId/gtm/campaigns',
    getParentRoute: () => LangRoute,
  } as any)
const LangWorkspaceWorkspaceIdChatsChatIdRoute =
  LangWorkspaceWorkspaceIdChatsChatIdRouteImport.update({
    id: '/workspace/$workspaceId/chats/$chatId',
    path: '/workspace/$workspaceId/chats/$chatId',
    getParentRoute: () => LangRoute,
  } as any)
const LangWorkspaceWorkspaceIdAgentsNewRoute =
  LangWorkspaceWorkspaceIdAgentsNewRouteImport.update({
    id: '/workspace/$workspaceId/agents/new',
    path: '/workspace/$workspaceId/agents/new',
    getParentRoute: () => LangRoute,
  } as any)
const LangOrganizationAgentsAgentIdEditRoute =
  LangOrganizationAgentsAgentIdEditRouteImport.update({
    id: '/organization/agents/$agentId/edit',
    path: '/organization/agents/$agentId/edit',
    getParentRoute: () => LangRoute,
  } as any)
const LangWorkspaceWorkspaceIdAgentsAgentIdEditRoute =
  LangWorkspaceWorkspaceIdAgentsAgentIdEditRouteImport.update({
    id: '/workspace/$workspaceId/agents/$agentId/edit',
    path: '/workspace/$workspaceId/agents/$agentId/edit',
    getParentRoute: () => LangRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$lang': typeof LangRouteWithChildren
  '/resources': typeof ResourcesRouteWithChildren
  '/$lang/app': typeof LangAppRoute
  '/$lang/check-email': typeof LangCheckEmailRoute
  '/$lang/demo': typeof LangDemoRoute
  '/$lang/integrations': typeof LangIntegrationsRoute
  '/$lang/pending-approval': typeof LangPendingApprovalRoute
  '/$lang/pricing': typeof LangPricingRoute
  '/$lang/privacy': typeof LangPrivacyRoute
  '/$lang/refund-policy': typeof LangRefundPolicyRoute
  '/$lang/resources': typeof LangResourcesRouteWithChildren
  '/$lang/security': typeof LangSecurityRoute
  '/$lang/solutions': typeof LangSolutionsRoute
  '/$lang/terms': typeof LangTermsRoute
  '/$lang/trust': typeof LangTrustRoute
  '/$lang/': typeof LangIndexRoute
  '/confirm-email-change/': typeof ConfirmEmailChangeIndexRoute
  '/resources/': typeof ResourcesIndexRoute
  '/verify-email/': typeof VerifyEmailIndexRoute
  '/$lang/gtm/$runId': typeof LangGtmRunIdRoute
  '/$lang/invites/$inviteId': typeof LangInvitesInviteIdRoute
  '/$lang/mcp/authorize': typeof LangMcpAuthorizeRoute
  '/$lang/onboarding/free': typeof LangOnboardingFreeRoute
  '/$lang/org-invites/$token': typeof LangOrgInvitesTokenRoute
  '/$lang/settings/ai-integrations': typeof LangSettingsAiIntegrationsRoute
  '/$lang/settings/billing': typeof LangSettingsBillingRoute
  '/$lang/settings/general': typeof LangSettingsGeneralRoute
  '/$lang/settings/organization': typeof LangSettingsOrganizationRoute
  '/$lang/subscription/organization': typeof LangSubscriptionOrganizationRoute
  '/$lang/subscription/pilot': typeof LangSubscriptionPilotRoute
  '/$lang/workspace/create': typeof LangWorkspaceCreateRoute
  '/oauth/github/complete': typeof OauthGithubCompleteRoute
  '/resources/$category/$slug': typeof ResourcesCategorySlugRoute
  '/$lang/auth/': typeof LangAuthIndexRoute
  '/$lang/billing/': typeof LangBillingIndexRoute
  '/$lang/confirm-email-change/': typeof LangConfirmEmailChangeIndexRoute
  '/$lang/dashboard/': typeof LangDashboardIndexRoute
  '/$lang/home/': typeof LangHomeIndexRoute
  '/$lang/login/': typeof LangLoginIndexRoute
  '/$lang/organization/': typeof LangOrganizationIndexRoute
  '/$lang/resources/': typeof LangResourcesIndexRoute
  '/$lang/settings/': typeof LangSettingsIndexRoute
  '/$lang/signup/': typeof LangSignupIndexRoute
  '/$lang/subscription/': typeof LangSubscriptionIndexRoute
  '/$lang/verify-email/': typeof LangVerifyEmailIndexRoute
  '/$lang/workspace/': typeof LangWorkspaceIndexRoute
  '/$lang/gtm/purchase/$checkoutId': typeof LangGtmPurchaseCheckoutIdRoute
  '/$lang/gtm/start/$checkoutId': typeof LangGtmStartCheckoutIdRoute
  '/$lang/organization/agents/new': typeof LangOrganizationAgentsNewRoute
  '/$lang/resources/$category/$slug': typeof LangResourcesCategorySlugRoute
  '/$lang/workspace/$workspaceId/settings': typeof LangWorkspaceWorkspaceIdSettingsRoute
  '/$lang/organization/agents/': typeof LangOrganizationAgentsIndexRoute
  '/$lang/organization/automations/': typeof LangOrganizationAutomationsIndexRoute
  '/$lang/workspace/$workspaceId/': typeof LangWorkspaceWorkspaceIdIndexRoute
  '/$lang/organization/agents/$agentId/edit': typeof LangOrganizationAgentsAgentIdEditRoute
  '/$lang/workspace/$workspaceId/agents/new': typeof LangWorkspaceWorkspaceIdAgentsNewRoute
  '/$lang/workspace/$workspaceId/chats/$chatId': typeof LangWorkspaceWorkspaceIdChatsChatIdRoute
  '/$lang/workspace/$workspaceId/gtm/campaigns': typeof LangWorkspaceWorkspaceIdGtmCampaignsRoute
  '/$lang/workspace/$workspaceId/gtm/inbox': typeof LangWorkspaceWorkspaceIdGtmInboxRoute
  '/$lang/workspace/$workspaceId/gtm/leads': typeof LangWorkspaceWorkspaceIdGtmLeadsRoute
  '/$lang/workspace/$workspaceId/gtm/settings': typeof LangWorkspaceWorkspaceIdGtmSettingsRoute
  '/$lang/workspace/$workspaceId/agents/': typeof LangWorkspaceWorkspaceIdAgentsIndexRoute
  '/$lang/workspace/$workspaceId/gtm/': typeof LangWorkspaceWorkspaceIdGtmIndexRoute
  '/$lang/workspace/$workspaceId/agents/$agentId/edit': typeof LangWorkspaceWorkspaceIdAgentsAgentIdEditRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$lang/app': typeof LangAppRoute
  '/$lang/check-email': typeof LangCheckEmailRoute
  '/$lang/demo': typeof LangDemoRoute
  '/$lang/integrations': typeof LangIntegrationsRoute
  '/$lang/pending-approval': typeof LangPendingApprovalRoute
  '/$lang/pricing': typeof LangPricingRoute
  '/$lang/privacy': typeof LangPrivacyRoute
  '/$lang/refund-policy': typeof LangRefundPolicyRoute
  '/$lang/security': typeof LangSecurityRoute
  '/$lang/solutions': typeof LangSolutionsRoute
  '/$lang/terms': typeof LangTermsRoute
  '/$lang/trust': typeof LangTrustRoute
  '/$lang': typeof LangIndexRoute
  '/confirm-email-change': typeof ConfirmEmailChangeIndexRoute
  '/resources': typeof ResourcesIndexRoute
  '/verify-email': typeof VerifyEmailIndexRoute
  '/$lang/gtm/$runId': typeof LangGtmRunIdRoute
  '/$lang/invites/$inviteId': typeof LangInvitesInviteIdRoute
  '/$lang/mcp/authorize': typeof LangMcpAuthorizeRoute
  '/$lang/onboarding/free': typeof LangOnboardingFreeRoute
  '/$lang/org-invites/$token': typeof LangOrgInvitesTokenRoute
  '/$lang/settings/ai-integrations': typeof LangSettingsAiIntegrationsRoute
  '/$lang/settings/billing': typeof LangSettingsBillingRoute
  '/$lang/settings/general': typeof LangSettingsGeneralRoute
  '/$lang/settings/organization': typeof LangSettingsOrganizationRoute
  '/$lang/subscription/organization': typeof LangSubscriptionOrganizationRoute
  '/$lang/subscription/pilot': typeof LangSubscriptionPilotRoute
  '/$lang/workspace/create': typeof LangWorkspaceCreateRoute
  '/oauth/github/complete': typeof OauthGithubCompleteRoute
  '/resources/$category/$slug': typeof ResourcesCategorySlugRoute
  '/$lang/auth': typeof LangAuthIndexRoute
  '/$lang/billing': typeof LangBillingIndexRoute
  '/$lang/confirm-email-change': typeof LangConfirmEmailChangeIndexRoute
  '/$lang/dashboard': typeof LangDashboardIndexRoute
  '/$lang/home': typeof LangHomeIndexRoute
  '/$lang/login': typeof LangLoginIndexRoute
  '/$lang/organization': typeof LangOrganizationIndexRoute
  '/$lang/resources': typeof LangResourcesIndexRoute
  '/$lang/settings': typeof LangSettingsIndexRoute
  '/$lang/signup': typeof LangSignupIndexRoute
  '/$lang/subscription': typeof LangSubscriptionIndexRoute
  '/$lang/verify-email': typeof LangVerifyEmailIndexRoute
  '/$lang/workspace': typeof LangWorkspaceIndexRoute
  '/$lang/gtm/purchase/$checkoutId': typeof LangGtmPurchaseCheckoutIdRoute
  '/$lang/gtm/start/$checkoutId': typeof LangGtmStartCheckoutIdRoute
  '/$lang/organization/agents/new': typeof LangOrganizationAgentsNewRoute
  '/$lang/resources/$category/$slug': typeof LangResourcesCategorySlugRoute
  '/$lang/workspace/$workspaceId/settings': typeof LangWorkspaceWorkspaceIdSettingsRoute
  '/$lang/organization/agents': typeof LangOrganizationAgentsIndexRoute
  '/$lang/organization/automations': typeof LangOrganizationAutomationsIndexRoute
  '/$lang/workspace/$workspaceId': typeof LangWorkspaceWorkspaceIdIndexRoute
  '/$lang/organization/agents/$agentId/edit': typeof LangOrganizationAgentsAgentIdEditRoute
  '/$lang/workspace/$workspaceId/agents/new': typeof LangWorkspaceWorkspaceIdAgentsNewRoute
  '/$lang/workspace/$workspaceId/chats/$chatId': typeof LangWorkspaceWorkspaceIdChatsChatIdRoute
  '/$lang/workspace/$workspaceId/gtm/campaigns': typeof LangWorkspaceWorkspaceIdGtmCampaignsRoute
  '/$lang/workspace/$workspaceId/gtm/inbox': typeof LangWorkspaceWorkspaceIdGtmInboxRoute
  '/$lang/workspace/$workspaceId/gtm/leads': typeof LangWorkspaceWorkspaceIdGtmLeadsRoute
  '/$lang/workspace/$workspaceId/gtm/settings': typeof LangWorkspaceWorkspaceIdGtmSettingsRoute
  '/$lang/workspace/$workspaceId/agents': typeof LangWorkspaceWorkspaceIdAgentsIndexRoute
  '/$lang/workspace/$workspaceId/gtm': typeof LangWorkspaceWorkspaceIdGtmIndexRoute
  '/$lang/workspace/$workspaceId/agents/$agentId/edit': typeof LangWorkspaceWorkspaceIdAgentsAgentIdEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$lang': typeof LangRouteWithChildren
  '/resources': typeof ResourcesRouteWithChildren
  '/$lang/app': typeof LangAppRoute
  '/$lang/check-email': typeof LangCheckEmailRoute
  '/$lang/demo': typeof LangDemoRoute
  '/$lang/integrations': typeof LangIntegrationsRoute
  '/$lang/pending-approval': typeof LangPendingApprovalRoute
  '/$lang/pricing': typeof LangPricingRoute
  '/$lang/privacy': typeof LangPrivacyRoute
  '/$lang/refund-policy': typeof LangRefundPolicyRoute
  '/$lang/resources': typeof LangResourcesRouteWithChildren
  '/$lang/security': typeof LangSecurityRoute
  '/$lang/solutions': typeof LangSolutionsRoute
  '/$lang/terms': typeof LangTermsRoute
  '/$lang/trust': typeof LangTrustRoute
  '/$lang/': typeof LangIndexRoute
  '/confirm-email-change/': typeof ConfirmEmailChangeIndexRoute
  '/resources/': typeof ResourcesIndexRoute
  '/verify-email/': typeof VerifyEmailIndexRoute
  '/$lang/gtm/$runId': typeof LangGtmRunIdRoute
  '/$lang/invites/$inviteId': typeof LangInvitesInviteIdRoute
  '/$lang/mcp/authorize': typeof LangMcpAuthorizeRoute
  '/$lang/onboarding/free': typeof LangOnboardingFreeRoute
  '/$lang/org-invites/$token': typeof LangOrgInvitesTokenRoute
  '/$lang/settings/ai-integrations': typeof LangSettingsAiIntegrationsRoute
  '/$lang/settings/billing': typeof LangSettingsBillingRoute
  '/$lang/settings/general': typeof LangSettingsGeneralRoute
  '/$lang/settings/organization': typeof LangSettingsOrganizationRoute
  '/$lang/subscription/organization': typeof LangSubscriptionOrganizationRoute
  '/$lang/subscription/pilot': typeof LangSubscriptionPilotRoute
  '/$lang/workspace/create': typeof LangWorkspaceCreateRoute
  '/oauth/github/complete': typeof OauthGithubCompleteRoute
  '/resources/$category/$slug': typeof ResourcesCategorySlugRoute
  '/$lang/auth/': typeof LangAuthIndexRoute
  '/$lang/billing/': typeof LangBillingIndexRoute
  '/$lang/confirm-email-change/': typeof LangConfirmEmailChangeIndexRoute
  '/$lang/dashboard/': typeof LangDashboardIndexRoute
  '/$lang/home/': typeof LangHomeIndexRoute
  '/$lang/login/': typeof LangLoginIndexRoute
  '/$lang/organization/': typeof LangOrganizationIndexRoute
  '/$lang/resources/': typeof LangResourcesIndexRoute
  '/$lang/settings/': typeof LangSettingsIndexRoute
  '/$lang/signup/': typeof LangSignupIndexRoute
  '/$lang/subscription/': typeof LangSubscriptionIndexRoute
  '/$lang/verify-email/': typeof LangVerifyEmailIndexRoute
  '/$lang/workspace/': typeof LangWorkspaceIndexRoute
  '/$lang/gtm/purchase/$checkoutId': typeof LangGtmPurchaseCheckoutIdRoute
  '/$lang/gtm/start/$checkoutId': typeof LangGtmStartCheckoutIdRoute
  '/$lang/organization/agents/new': typeof LangOrganizationAgentsNewRoute
  '/$lang/resources/$category/$slug': typeof LangResourcesCategorySlugRoute
  '/$lang/workspace/$workspaceId/settings': typeof LangWorkspaceWorkspaceIdSettingsRoute
  '/$lang/organization/agents/': typeof LangOrganizationAgentsIndexRoute
  '/$lang/organization/automations/': typeof LangOrganizationAutomationsIndexRoute
  '/$lang/workspace/$workspaceId/': typeof LangWorkspaceWorkspaceIdIndexRoute
  '/$lang/organization/agents/$agentId/edit': typeof LangOrganizationAgentsAgentIdEditRoute
  '/$lang/workspace/$workspaceId/agents/new': typeof LangWorkspaceWorkspaceIdAgentsNewRoute
  '/$lang/workspace/$workspaceId/chats/$chatId': typeof LangWorkspaceWorkspaceIdChatsChatIdRoute
  '/$lang/workspace/$workspaceId/gtm/campaigns': typeof LangWorkspaceWorkspaceIdGtmCampaignsRoute
  '/$lang/workspace/$workspaceId/gtm/inbox': typeof LangWorkspaceWorkspaceIdGtmInboxRoute
  '/$lang/workspace/$workspaceId/gtm/leads': typeof LangWorkspaceWorkspaceIdGtmLeadsRoute
  '/$lang/workspace/$workspaceId/gtm/settings': typeof LangWorkspaceWorkspaceIdGtmSettingsRoute
  '/$lang/workspace/$workspaceId/agents/': typeof LangWorkspaceWorkspaceIdAgentsIndexRoute
  '/$lang/workspace/$workspaceId/gtm/': typeof LangWorkspaceWorkspaceIdGtmIndexRoute
  '/$lang/workspace/$workspaceId/agents/$agentId/edit': typeof LangWorkspaceWorkspaceIdAgentsAgentIdEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$lang'
    | '/resources'
    | '/$lang/app'
    | '/$lang/check-email'
    | '/$lang/demo'
    | '/$lang/integrations'
    | '/$lang/pending-approval'
    | '/$lang/pricing'
    | '/$lang/privacy'
    | '/$lang/refund-policy'
    | '/$lang/resources'
    | '/$lang/security'
    | '/$lang/solutions'
    | '/$lang/terms'
    | '/$lang/trust'
    | '/$lang/'
    | '/confirm-email-change/'
    | '/resources/'
    | '/verify-email/'
    | '/$lang/gtm/$runId'
    | '/$lang/invites/$inviteId'
    | '/$lang/mcp/authorize'
    | '/$lang/onboarding/free'
    | '/$lang/org-invites/$token'
    | '/$lang/settings/ai-integrations'
    | '/$lang/settings/billing'
    | '/$lang/settings/general'
    | '/$lang/settings/organization'
    | '/$lang/subscription/organization'
    | '/$lang/subscription/pilot'
    | '/$lang/workspace/create'
    | '/oauth/github/complete'
    | '/resources/$category/$slug'
    | '/$lang/auth/'
    | '/$lang/billing/'
    | '/$lang/confirm-email-change/'
    | '/$lang/dashboard/'
    | '/$lang/home/'
    | '/$lang/login/'
    | '/$lang/organization/'
    | '/$lang/resources/'
    | '/$lang/settings/'
    | '/$lang/signup/'
    | '/$lang/subscription/'
    | '/$lang/verify-email/'
    | '/$lang/workspace/'
    | '/$lang/gtm/purchase/$checkoutId'
    | '/$lang/gtm/start/$checkoutId'
    | '/$lang/organization/agents/new'
    | '/$lang/resources/$category/$slug'
    | '/$lang/workspace/$workspaceId/settings'
    | '/$lang/organization/agents/'
    | '/$lang/organization/automations/'
    | '/$lang/workspace/$workspaceId/'
    | '/$lang/organization/agents/$agentId/edit'
    | '/$lang/workspace/$workspaceId/agents/new'
    | '/$lang/workspace/$workspaceId/chats/$chatId'
    | '/$lang/workspace/$workspaceId/gtm/campaigns'
    | '/$lang/workspace/$workspaceId/gtm/inbox'
    | '/$lang/workspace/$workspaceId/gtm/leads'
    | '/$lang/workspace/$workspaceId/gtm/settings'
    | '/$lang/workspace/$workspaceId/agents/'
    | '/$lang/workspace/$workspaceId/gtm/'
    | '/$lang/workspace/$workspaceId/agents/$agentId/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$lang/app'
    | '/$lang/check-email'
    | '/$lang/demo'
    | '/$lang/integrations'
    | '/$lang/pending-approval'
    | '/$lang/pricing'
    | '/$lang/privacy'
    | '/$lang/refund-policy'
    | '/$lang/security'
    | '/$lang/solutions'
    | '/$lang/terms'
    | '/$lang/trust'
    | '/$lang'
    | '/confirm-email-change'
    | '/resources'
    | '/verify-email'
    | '/$lang/gtm/$runId'
    | '/$lang/invites/$inviteId'
    | '/$lang/mcp/authorize'
    | '/$lang/onboarding/free'
    | '/$lang/org-invites/$token'
    | '/$lang/settings/ai-integrations'
    | '/$lang/settings/billing'
    | '/$lang/settings/general'
    | '/$lang/settings/organization'
    | '/$lang/subscription/organization'
    | '/$lang/subscription/pilot'
    | '/$lang/workspace/create'
    | '/oauth/github/complete'
    | '/resources/$category/$slug'
    | '/$lang/auth'
    | '/$lang/billing'
    | '/$lang/confirm-email-change'
    | '/$lang/dashboard'
    | '/$lang/home'
    | '/$lang/login'
    | '/$lang/organization'
    | '/$lang/resources'
    | '/$lang/settings'
    | '/$lang/signup'
    | '/$lang/subscription'
    | '/$lang/verify-email'
    | '/$lang/workspace'
    | '/$lang/gtm/purchase/$checkoutId'
    | '/$lang/gtm/start/$checkoutId'
    | '/$lang/organization/agents/new'
    | '/$lang/resources/$category/$slug'
    | '/$lang/workspace/$workspaceId/settings'
    | '/$lang/organization/agents'
    | '/$lang/organization/automations'
    | '/$lang/workspace/$workspaceId'
    | '/$lang/organization/agents/$agentId/edit'
    | '/$lang/workspace/$workspaceId/agents/new'
    | '/$lang/workspace/$workspaceId/chats/$chatId'
    | '/$lang/workspace/$workspaceId/gtm/campaigns'
    | '/$lang/workspace/$workspaceId/gtm/inbox'
    | '/$lang/workspace/$workspaceId/gtm/leads'
    | '/$lang/workspace/$workspaceId/gtm/settings'
    | '/$lang/workspace/$workspaceId/agents'
    | '/$lang/workspace/$workspaceId/gtm'
    | '/$lang/workspace/$workspaceId/agents/$agentId/edit'
  id:
    | '__root__'
    | '/'
    | '/$lang'
    | '/resources'
    | '/$lang/app'
    | '/$lang/check-email'
    | '/$lang/demo'
    | '/$lang/integrations'
    | '/$lang/pending-approval'
    | '/$lang/pricing'
    | '/$lang/privacy'
    | '/$lang/refund-policy'
    | '/$lang/resources'
    | '/$lang/security'
    | '/$lang/solutions'
    | '/$lang/terms'
    | '/$lang/trust'
    | '/$lang/'
    | '/confirm-email-change/'
    | '/resources/'
    | '/verify-email/'
    | '/$lang/gtm/$runId'
    | '/$lang/invites/$inviteId'
    | '/$lang/mcp/authorize'
    | '/$lang/onboarding/free'
    | '/$lang/org-invites/$token'
    | '/$lang/settings/ai-integrations'
    | '/$lang/settings/billing'
    | '/$lang/settings/general'
    | '/$lang/settings/organization'
    | '/$lang/subscription/organization'
    | '/$lang/subscription/pilot'
    | '/$lang/workspace/create'
    | '/oauth/github/complete'
    | '/resources/$category/$slug'
    | '/$lang/auth/'
    | '/$lang/billing/'
    | '/$lang/confirm-email-change/'
    | '/$lang/dashboard/'
    | '/$lang/home/'
    | '/$lang/login/'
    | '/$lang/organization/'
    | '/$lang/resources/'
    | '/$lang/settings/'
    | '/$lang/signup/'
    | '/$lang/subscription/'
    | '/$lang/verify-email/'
    | '/$lang/workspace/'
    | '/$lang/gtm/purchase/$checkoutId'
    | '/$lang/gtm/start/$checkoutId'
    | '/$lang/organization/agents/new'
    | '/$lang/resources/$category/$slug'
    | '/$lang/workspace/$workspaceId/settings'
    | '/$lang/organization/agents/'
    | '/$lang/organization/automations/'
    | '/$lang/workspace/$workspaceId/'
    | '/$lang/organization/agents/$agentId/edit'
    | '/$lang/workspace/$workspaceId/agents/new'
    | '/$lang/workspace/$workspaceId/chats/$chatId'
    | '/$lang/workspace/$workspaceId/gtm/campaigns'
    | '/$lang/workspace/$workspaceId/gtm/inbox'
    | '/$lang/workspace/$workspaceId/gtm/leads'
    | '/$lang/workspace/$workspaceId/gtm/settings'
    | '/$lang/workspace/$workspaceId/agents/'
    | '/$lang/workspace/$workspaceId/gtm/'
    | '/$lang/workspace/$workspaceId/agents/$agentId/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LangRoute: typeof LangRouteWithChildren
  ResourcesRoute: typeof ResourcesRouteWithChildren
  ConfirmEmailChangeIndexRoute: typeof ConfirmEmailChangeIndexRoute
  VerifyEmailIndexRoute: typeof VerifyEmailIndexRoute
  OauthGithubCompleteRoute: typeof OauthGithubCompleteRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/resources': {
      id: '/resources'
      path: '/resources'
      fullPath: '/resources'
      preLoaderRoute: typeof ResourcesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$lang': {
      id: '/$lang'
      path: '/$lang'
      fullPath: '/$lang'
      preLoaderRoute: typeof LangRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify-email/': {
      id: '/verify-email/'
      path: '/verify-email'
      fullPath: '/verify-email/'
      preLoaderRoute: typeof VerifyEmailIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/resources/': {
      id: '/resources/'
      path: '/'
      fullPath: '/resources/'
      preLoaderRoute: typeof ResourcesIndexRouteImport
      parentRoute: typeof ResourcesRoute
    }
    '/confirm-email-change/': {
      id: '/confirm-email-change/'
      path: '/confirm-email-change'
      fullPath: '/confirm-email-change/'
      preLoaderRoute: typeof ConfirmEmailChangeIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$lang/': {
      id: '/$lang/'
      path: '/'
      fullPath: '/$lang/'
      preLoaderRoute: typeof LangIndexRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/trust': {
      id: '/$lang/trust'
      path: '/trust'
      fullPath: '/$lang/trust'
      preLoaderRoute: typeof LangTrustRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/terms': {
      id: '/$lang/terms'
      path: '/terms'
      fullPath: '/$lang/terms'
      preLoaderRoute: typeof LangTermsRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/solutions': {
      id: '/$lang/solutions'
      path: '/solutions'
      fullPath: '/$lang/solutions'
      preLoaderRoute: typeof LangSolutionsRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/security': {
      id: '/$lang/security'
      path: '/security'
      fullPath: '/$lang/security'
      preLoaderRoute: typeof LangSecurityRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/resources': {
      id: '/$lang/resources'
      path: '/resources'
      fullPath: '/$lang/resources'
      preLoaderRoute: typeof LangResourcesRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/refund-policy': {
      id: '/$lang/refund-policy'
      path: '/refund-policy'
      fullPath: '/$lang/refund-policy'
      preLoaderRoute: typeof LangRefundPolicyRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/privacy': {
      id: '/$lang/privacy'
      path: '/privacy'
      fullPath: '/$lang/privacy'
      preLoaderRoute: typeof LangPrivacyRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/pricing': {
      id: '/$lang/pricing'
      path: '/pricing'
      fullPath: '/$lang/pricing'
      preLoaderRoute: typeof LangPricingRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/pending-approval': {
      id: '/$lang/pending-approval'
      path: '/pending-approval'
      fullPath: '/$lang/pending-approval'
      preLoaderRoute: typeof LangPendingApprovalRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/integrations': {
      id: '/$lang/integrations'
      path: '/integrations'
      fullPath: '/$lang/integrations'
      preLoaderRoute: typeof LangIntegrationsRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/demo': {
      id: '/$lang/demo'
      path: '/demo'
      fullPath: '/$lang/demo'
      preLoaderRoute: typeof LangDemoRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/check-email': {
      id: '/$lang/check-email'
      path: '/check-email'
      fullPath: '/$lang/check-email'
      preLoaderRoute: typeof LangCheckEmailRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/app': {
      id: '/$lang/app'
      path: '/app'
      fullPath: '/$lang/app'
      preLoaderRoute: typeof LangAppRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/workspace/': {
      id: '/$lang/workspace/'
      path: '/workspace'
      fullPath: '/$lang/workspace/'
      preLoaderRoute: typeof LangWorkspaceIndexRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/verify-email/': {
      id: '/$lang/verify-email/'
      path: '/verify-email'
      fullPath: '/$lang/verify-email/'
      preLoaderRoute: typeof LangVerifyEmailIndexRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/subscription/': {
      id: '/$lang/subscription/'
      path: '/subscription'
      fullPath: '/$lang/subscription/'
      preLoaderRoute: typeof LangSubscriptionIndexRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/signup/': {
      id: '/$lang/signup/'
      path: '/signup'
      fullPath: '/$lang/signup/'
      preLoaderRoute: typeof LangSignupIndexRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/settings/': {
      id: '/$lang/settings/'
      path: '/settings'
      fullPath: '/$lang/settings/'
      preLoaderRoute: typeof LangSettingsIndexRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/resources/': {
      id: '/$lang/resources/'
      path: '/'
      fullPath: '/$lang/resources/'
      preLoaderRoute: typeof LangResourcesIndexRouteImport
      parentRoute: typeof LangResourcesRoute
    }
    '/$lang/organization/': {
      id: '/$lang/organization/'
      path: '/organization'
      fullPath: '/$lang/organization/'
      preLoaderRoute: typeof LangOrganizationIndexRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/login/': {
      id: '/$lang/login/'
      path: '/login'
      fullPath: '/$lang/login/'
      preLoaderRoute: typeof LangLoginIndexRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/home/': {
      id: '/$lang/home/'
      path: '/home'
      fullPath: '/$lang/home/'
      preLoaderRoute: typeof LangHomeIndexRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/dashboard/': {
      id: '/$lang/dashboard/'
      path: '/dashboard'
      fullPath: '/$lang/dashboard/'
      preLoaderRoute: typeof LangDashboardIndexRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/confirm-email-change/': {
      id: '/$lang/confirm-email-change/'
      path: '/confirm-email-change'
      fullPath: '/$lang/confirm-email-change/'
      preLoaderRoute: typeof LangConfirmEmailChangeIndexRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/billing/': {
      id: '/$lang/billing/'
      path: '/billing'
      fullPath: '/$lang/billing/'
      preLoaderRoute: typeof LangBillingIndexRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/auth/': {
      id: '/$lang/auth/'
      path: '/auth'
      fullPath: '/$lang/auth/'
      preLoaderRoute: typeof LangAuthIndexRouteImport
      parentRoute: typeof LangRoute
    }
    '/resources/$category/$slug': {
      id: '/resources/$category/$slug'
      path: '/$category/$slug'
      fullPath: '/resources/$category/$slug'
      preLoaderRoute: typeof ResourcesCategorySlugRouteImport
      parentRoute: typeof ResourcesRoute
    }
    '/oauth/github/complete': {
      id: '/oauth/github/complete'
      path: '/oauth/github/complete'
      fullPath: '/oauth/github/complete'
      preLoaderRoute: typeof OauthGithubCompleteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$lang/workspace/create': {
      id: '/$lang/workspace/create'
      path: '/workspace/create'
      fullPath: '/$lang/workspace/create'
      preLoaderRoute: typeof LangWorkspaceCreateRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/subscription/pilot': {
      id: '/$lang/subscription/pilot'
      path: '/subscription/pilot'
      fullPath: '/$lang/subscription/pilot'
      preLoaderRoute: typeof LangSubscriptionPilotRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/subscription/organization': {
      id: '/$lang/subscription/organization'
      path: '/subscription/organization'
      fullPath: '/$lang/subscription/organization'
      preLoaderRoute: typeof LangSubscriptionOrganizationRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/settings/organization': {
      id: '/$lang/settings/organization'
      path: '/settings/organization'
      fullPath: '/$lang/settings/organization'
      preLoaderRoute: typeof LangSettingsOrganizationRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/settings/general': {
      id: '/$lang/settings/general'
      path: '/settings/general'
      fullPath: '/$lang/settings/general'
      preLoaderRoute: typeof LangSettingsGeneralRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/settings/billing': {
      id: '/$lang/settings/billing'
      path: '/settings/billing'
      fullPath: '/$lang/settings/billing'
      preLoaderRoute: typeof LangSettingsBillingRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/settings/ai-integrations': {
      id: '/$lang/settings/ai-integrations'
      path: '/settings/ai-integrations'
      fullPath: '/$lang/settings/ai-integrations'
      preLoaderRoute: typeof LangSettingsAiIntegrationsRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/org-invites/$token': {
      id: '/$lang/org-invites/$token'
      path: '/org-invites/$token'
      fullPath: '/$lang/org-invites/$token'
      preLoaderRoute: typeof LangOrgInvitesTokenRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/onboarding/free': {
      id: '/$lang/onboarding/free'
      path: '/onboarding/free'
      fullPath: '/$lang/onboarding/free'
      preLoaderRoute: typeof LangOnboardingFreeRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/mcp/authorize': {
      id: '/$lang/mcp/authorize'
      path: '/mcp/authorize'
      fullPath: '/$lang/mcp/authorize'
      preLoaderRoute: typeof LangMcpAuthorizeRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/invites/$inviteId': {
      id: '/$lang/invites/$inviteId'
      path: '/invites/$inviteId'
      fullPath: '/$lang/invites/$inviteId'
      preLoaderRoute: typeof LangInvitesInviteIdRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/gtm/$runId': {
      id: '/$lang/gtm/$runId'
      path: '/gtm/$runId'
      fullPath: '/$lang/gtm/$runId'
      preLoaderRoute: typeof LangGtmRunIdRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/workspace/$workspaceId/': {
      id: '/$lang/workspace/$workspaceId/'
      path: '/workspace/$workspaceId'
      fullPath: '/$lang/workspace/$workspaceId/'
      preLoaderRoute: typeof LangWorkspaceWorkspaceIdIndexRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/organization/automations/': {
      id: '/$lang/organization/automations/'
      path: '/organization/automations'
      fullPath: '/$lang/organization/automations/'
      preLoaderRoute: typeof LangOrganizationAutomationsIndexRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/organization/agents/': {
      id: '/$lang/organization/agents/'
      path: '/organization/agents'
      fullPath: '/$lang/organization/agents/'
      preLoaderRoute: typeof LangOrganizationAgentsIndexRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/workspace/$workspaceId/settings': {
      id: '/$lang/workspace/$workspaceId/settings'
      path: '/workspace/$workspaceId/settings'
      fullPath: '/$lang/workspace/$workspaceId/settings'
      preLoaderRoute: typeof LangWorkspaceWorkspaceIdSettingsRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/resources/$category/$slug': {
      id: '/$lang/resources/$category/$slug'
      path: '/$category/$slug'
      fullPath: '/$lang/resources/$category/$slug'
      preLoaderRoute: typeof LangResourcesCategorySlugRouteImport
      parentRoute: typeof LangResourcesRoute
    }
    '/$lang/organization/agents/new': {
      id: '/$lang/organization/agents/new'
      path: '/organization/agents/new'
      fullPath: '/$lang/organization/agents/new'
      preLoaderRoute: typeof LangOrganizationAgentsNewRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/gtm/start/$checkoutId': {
      id: '/$lang/gtm/start/$checkoutId'
      path: '/gtm/start/$checkoutId'
      fullPath: '/$lang/gtm/start/$checkoutId'
      preLoaderRoute: typeof LangGtmStartCheckoutIdRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/gtm/purchase/$checkoutId': {
      id: '/$lang/gtm/purchase/$checkoutId'
      path: '/gtm/purchase/$checkoutId'
      fullPath: '/$lang/gtm/purchase/$checkoutId'
      preLoaderRoute: typeof LangGtmPurchaseCheckoutIdRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/workspace/$workspaceId/gtm/': {
      id: '/$lang/workspace/$workspaceId/gtm/'
      path: '/workspace/$workspaceId/gtm'
      fullPath: '/$lang/workspace/$workspaceId/gtm/'
      preLoaderRoute: typeof LangWorkspaceWorkspaceIdGtmIndexRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/workspace/$workspaceId/agents/': {
      id: '/$lang/workspace/$workspaceId/agents/'
      path: '/workspace/$workspaceId/agents'
      fullPath: '/$lang/workspace/$workspaceId/agents/'
      preLoaderRoute: typeof LangWorkspaceWorkspaceIdAgentsIndexRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/workspace/$workspaceId/gtm/settings': {
      id: '/$lang/workspace/$workspaceId/gtm/settings'
      path: '/workspace/$workspaceId/gtm/settings'
      fullPath: '/$lang/workspace/$workspaceId/gtm/settings'
      preLoaderRoute: typeof LangWorkspaceWorkspaceIdGtmSettingsRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/workspace/$workspaceId/gtm/leads': {
      id: '/$lang/workspace/$workspaceId/gtm/leads'
      path: '/workspace/$workspaceId/gtm/leads'
      fullPath: '/$lang/workspace/$workspaceId/gtm/leads'
      preLoaderRoute: typeof LangWorkspaceWorkspaceIdGtmLeadsRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/workspace/$workspaceId/gtm/inbox': {
      id: '/$lang/workspace/$workspaceId/gtm/inbox'
      path: '/workspace/$workspaceId/gtm/inbox'
      fullPath: '/$lang/workspace/$workspaceId/gtm/inbox'
      preLoaderRoute: typeof LangWorkspaceWorkspaceIdGtmInboxRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/workspace/$workspaceId/gtm/campaigns': {
      id: '/$lang/workspace/$workspaceId/gtm/campaigns'
      path: '/workspace/$workspaceId/gtm/campaigns'
      fullPath: '/$lang/workspace/$workspaceId/gtm/campaigns'
      preLoaderRoute: typeof LangWorkspaceWorkspaceIdGtmCampaignsRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/workspace/$workspaceId/chats/$chatId': {
      id: '/$lang/workspace/$workspaceId/chats/$chatId'
      path: '/workspace/$workspaceId/chats/$chatId'
      fullPath: '/$lang/workspace/$workspaceId/chats/$chatId'
      preLoaderRoute: typeof LangWorkspaceWorkspaceIdChatsChatIdRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/workspace/$workspaceId/agents/new': {
      id: '/$lang/workspace/$workspaceId/agents/new'
      path: '/workspace/$workspaceId/agents/new'
      fullPath: '/$lang/workspace/$workspaceId/agents/new'
      preLoaderRoute: typeof LangWorkspaceWorkspaceIdAgentsNewRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/organization/agents/$agentId/edit': {
      id: '/$lang/organization/agents/$agentId/edit'
      path: '/organization/agents/$agentId/edit'
      fullPath: '/$lang/organization/agents/$agentId/edit'
      preLoaderRoute: typeof LangOrganizationAgentsAgentIdEditRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/workspace/$workspaceId/agents/$agentId/edit': {
      id: '/$lang/workspace/$workspaceId/agents/$agentId/edit'
      path: '/workspace/$workspaceId/agents/$agentId/edit'
      fullPath: '/$lang/workspace/$workspaceId/agents/$agentId/edit'
      preLoaderRoute: typeof LangWorkspaceWorkspaceIdAgentsAgentIdEditRouteImport
      parentRoute: typeof LangRoute
    }
  }
}

interface LangResourcesRouteChildren {
  LangResourcesIndexRoute: typeof LangResourcesIndexRoute
  LangResourcesCategorySlugRoute: typeof LangResourcesCategorySlugRoute
}

const LangResourcesRouteChildren: LangResourcesRouteChildren = {
  LangResourcesIndexRoute: LangResourcesIndexRoute,
  LangResourcesCategorySlugRoute: LangResourcesCategorySlugRoute,
}

const LangResourcesRouteWithChildren = LangResourcesRoute._addFileChildren(
  LangResourcesRouteChildren,
)

interface LangRouteChildren {
  LangAppRoute: typeof LangAppRoute
  LangCheckEmailRoute: typeof LangCheckEmailRoute
  LangDemoRoute: typeof LangDemoRoute
  LangIntegrationsRoute: typeof LangIntegrationsRoute
  LangPendingApprovalRoute: typeof LangPendingApprovalRoute
  LangPricingRoute: typeof LangPricingRoute
  LangPrivacyRoute: typeof LangPrivacyRoute
  LangRefundPolicyRoute: typeof LangRefundPolicyRoute
  LangResourcesRoute: typeof LangResourcesRouteWithChildren
  LangSecurityRoute: typeof LangSecurityRoute
  LangSolutionsRoute: typeof LangSolutionsRoute
  LangTermsRoute: typeof LangTermsRoute
  LangTrustRoute: typeof LangTrustRoute
  LangIndexRoute: typeof LangIndexRoute
  LangGtmRunIdRoute: typeof LangGtmRunIdRoute
  LangInvitesInviteIdRoute: typeof LangInvitesInviteIdRoute
  LangMcpAuthorizeRoute: typeof LangMcpAuthorizeRoute
  LangOnboardingFreeRoute: typeof LangOnboardingFreeRoute
  LangOrgInvitesTokenRoute: typeof LangOrgInvitesTokenRoute
  LangSettingsAiIntegrationsRoute: typeof LangSettingsAiIntegrationsRoute
  LangSettingsBillingRoute: typeof LangSettingsBillingRoute
  LangSettingsGeneralRoute: typeof LangSettingsGeneralRoute
  LangSettingsOrganizationRoute: typeof LangSettingsOrganizationRoute
  LangSubscriptionOrganizationRoute: typeof LangSubscriptionOrganizationRoute
  LangSubscriptionPilotRoute: typeof LangSubscriptionPilotRoute
  LangWorkspaceCreateRoute: typeof LangWorkspaceCreateRoute
  LangAuthIndexRoute: typeof LangAuthIndexRoute
  LangBillingIndexRoute: typeof LangBillingIndexRoute
  LangConfirmEmailChangeIndexRoute: typeof LangConfirmEmailChangeIndexRoute
  LangDashboardIndexRoute: typeof LangDashboardIndexRoute
  LangHomeIndexRoute: typeof LangHomeIndexRoute
  LangLoginIndexRoute: typeof LangLoginIndexRoute
  LangOrganizationIndexRoute: typeof LangOrganizationIndexRoute
  LangSettingsIndexRoute: typeof LangSettingsIndexRoute
  LangSignupIndexRoute: typeof LangSignupIndexRoute
  LangSubscriptionIndexRoute: typeof LangSubscriptionIndexRoute
  LangVerifyEmailIndexRoute: typeof LangVerifyEmailIndexRoute
  LangWorkspaceIndexRoute: typeof LangWorkspaceIndexRoute
  LangGtmPurchaseCheckoutIdRoute: typeof LangGtmPurchaseCheckoutIdRoute
  LangGtmStartCheckoutIdRoute: typeof LangGtmStartCheckoutIdRoute
  LangOrganizationAgentsNewRoute: typeof LangOrganizationAgentsNewRoute
  LangWorkspaceWorkspaceIdSettingsRoute: typeof LangWorkspaceWorkspaceIdSettingsRoute
  LangOrganizationAgentsIndexRoute: typeof LangOrganizationAgentsIndexRoute
  LangOrganizationAutomationsIndexRoute: typeof LangOrganizationAutomationsIndexRoute
  LangWorkspaceWorkspaceIdIndexRoute: typeof LangWorkspaceWorkspaceIdIndexRoute
  LangOrganizationAgentsAgentIdEditRoute: typeof LangOrganizationAgentsAgentIdEditRoute
  LangWorkspaceWorkspaceIdAgentsNewRoute: typeof LangWorkspaceWorkspaceIdAgentsNewRoute
  LangWorkspaceWorkspaceIdChatsChatIdRoute: typeof LangWorkspaceWorkspaceIdChatsChatIdRoute
  LangWorkspaceWorkspaceIdGtmCampaignsRoute: typeof LangWorkspaceWorkspaceIdGtmCampaignsRoute
  LangWorkspaceWorkspaceIdGtmInboxRoute: typeof LangWorkspaceWorkspaceIdGtmInboxRoute
  LangWorkspaceWorkspaceIdGtmLeadsRoute: typeof LangWorkspaceWorkspaceIdGtmLeadsRoute
  LangWorkspaceWorkspaceIdGtmSettingsRoute: typeof LangWorkspaceWorkspaceIdGtmSettingsRoute
  LangWorkspaceWorkspaceIdAgentsIndexRoute: typeof LangWorkspaceWorkspaceIdAgentsIndexRoute
  LangWorkspaceWorkspaceIdGtmIndexRoute: typeof LangWorkspaceWorkspaceIdGtmIndexRoute
  LangWorkspaceWorkspaceIdAgentsAgentIdEditRoute: typeof LangWorkspaceWorkspaceIdAgentsAgentIdEditRoute
}

const LangRouteChildren: LangRouteChildren = {
  LangAppRoute: LangAppRoute,
  LangCheckEmailRoute: LangCheckEmailRoute,
  LangDemoRoute: LangDemoRoute,
  LangIntegrationsRoute: LangIntegrationsRoute,
  LangPendingApprovalRoute: LangPendingApprovalRoute,
  LangPricingRoute: LangPricingRoute,
  LangPrivacyRoute: LangPrivacyRoute,
  LangRefundPolicyRoute: LangRefundPolicyRoute,
  LangResourcesRoute: LangResourcesRouteWithChildren,
  LangSecurityRoute: LangSecurityRoute,
  LangSolutionsRoute: LangSolutionsRoute,
  LangTermsRoute: LangTermsRoute,
  LangTrustRoute: LangTrustRoute,
  LangIndexRoute: LangIndexRoute,
  LangGtmRunIdRoute: LangGtmRunIdRoute,
  LangInvitesInviteIdRoute: LangInvitesInviteIdRoute,
  LangMcpAuthorizeRoute: LangMcpAuthorizeRoute,
  LangOnboardingFreeRoute: LangOnboardingFreeRoute,
  LangOrgInvitesTokenRoute: LangOrgInvitesTokenRoute,
  LangSettingsAiIntegrationsRoute: LangSettingsAiIntegrationsRoute,
  LangSettingsBillingRoute: LangSettingsBillingRoute,
  LangSettingsGeneralRoute: LangSettingsGeneralRoute,
  LangSettingsOrganizationRoute: LangSettingsOrganizationRoute,
  LangSubscriptionOrganizationRoute: LangSubscriptionOrganizationRoute,
  LangSubscriptionPilotRoute: LangSubscriptionPilotRoute,
  LangWorkspaceCreateRoute: LangWorkspaceCreateRoute,
  LangAuthIndexRoute: LangAuthIndexRoute,
  LangBillingIndexRoute: LangBillingIndexRoute,
  LangConfirmEmailChangeIndexRoute: LangConfirmEmailChangeIndexRoute,
  LangDashboardIndexRoute: LangDashboardIndexRoute,
  LangHomeIndexRoute: LangHomeIndexRoute,
  LangLoginIndexRoute: LangLoginIndexRoute,
  LangOrganizationIndexRoute: LangOrganizationIndexRoute,
  LangSettingsIndexRoute: LangSettingsIndexRoute,
  LangSignupIndexRoute: LangSignupIndexRoute,
  LangSubscriptionIndexRoute: LangSubscriptionIndexRoute,
  LangVerifyEmailIndexRoute: LangVerifyEmailIndexRoute,
  LangWorkspaceIndexRoute: LangWorkspaceIndexRoute,
  LangGtmPurchaseCheckoutIdRoute: LangGtmPurchaseCheckoutIdRoute,
  LangGtmStartCheckoutIdRoute: LangGtmStartCheckoutIdRoute,
  LangOrganizationAgentsNewRoute: LangOrganizationAgentsNewRoute,
  LangWorkspaceWorkspaceIdSettingsRoute: LangWorkspaceWorkspaceIdSettingsRoute,
  LangOrganizationAgentsIndexRoute: LangOrganizationAgentsIndexRoute,
  LangOrganizationAutomationsIndexRoute: LangOrganizationAutomationsIndexRoute,
  LangWorkspaceWorkspaceIdIndexRoute: LangWorkspaceWorkspaceIdIndexRoute,
  LangOrganizationAgentsAgentIdEditRoute:
    LangOrganizationAgentsAgentIdEditRoute,
  LangWorkspaceWorkspaceIdAgentsNewRoute:
    LangWorkspaceWorkspaceIdAgentsNewRoute,
  LangWorkspaceWorkspaceIdChatsChatIdRoute:
    LangWorkspaceWorkspaceIdChatsChatIdRoute,
  LangWorkspaceWorkspaceIdGtmCampaignsRoute:
    LangWorkspaceWorkspaceIdGtmCampaignsRoute,
  LangWorkspaceWorkspaceIdGtmInboxRoute: LangWorkspaceWorkspaceIdGtmInboxRoute,
  LangWorkspaceWorkspaceIdGtmLeadsRoute: LangWorkspaceWorkspaceIdGtmLeadsRoute,
  LangWorkspaceWorkspaceIdGtmSettingsRoute:
    LangWorkspaceWorkspaceIdGtmSettingsRoute,
  LangWorkspaceWorkspaceIdAgentsIndexRoute:
    LangWorkspaceWorkspaceIdAgentsIndexRoute,
  LangWorkspaceWorkspaceIdGtmIndexRoute: LangWorkspaceWorkspaceIdGtmIndexRoute,
  LangWorkspaceWorkspaceIdAgentsAgentIdEditRoute:
    LangWorkspaceWorkspaceIdAgentsAgentIdEditRoute,
}

const LangRouteWithChildren = LangRoute._addFileChildren(LangRouteChildren)

interface ResourcesRouteChildren {
  ResourcesIndexRoute: typeof ResourcesIndexRoute
  ResourcesCategorySlugRoute: typeof ResourcesCategorySlugRoute
}

const ResourcesRouteChildren: ResourcesRouteChildren = {
  ResourcesIndexRoute: ResourcesIndexRoute,
  ResourcesCategorySlugRoute: ResourcesCategorySlugRoute,
}

const ResourcesRouteWithChildren = ResourcesRoute._addFileChildren(
  ResourcesRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LangRoute: LangRouteWithChildren,
  ResourcesRoute: ResourcesRouteWithChildren,
  ConfirmEmailChangeIndexRoute: ConfirmEmailChangeIndexRoute,
  VerifyEmailIndexRoute: VerifyEmailIndexRoute,
  OauthGithubCompleteRoute: OauthGithubCompleteRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
